<template>
  <div>
    <button type="button" class="btn btn-primary" v-on:click="handleClick" :disabled="notificationCount == 0">
      <i class="fas fa-bell"></i>
      Notifications
      <span class="badge badge-light">{{notificationCount}}</span>
    </button>
    <slidy-thing id="claimNotifications" ref="claimNotifications" width="500px" openOn="right">
      <claim-notification :claimId="claimId" v-on:notification-count="handleNotificationCount" width="500px"/>
    </slidy-thing>
  </div>
</template>

<script>
import SlidyThing from "@/components/SlidyThing.vue";
import ClaimNotifications from "@/components/ClaimNotifications.vue";

export default {
  name: "ClaimNotificationsButton",
  props: ["claimId"],
  components: {
    "claim-notification": ClaimNotifications,
    "slidy-thing": SlidyThing
  },
  data: () => {
    return {
        notificationCount: 0
    };
  },
  computed: {
      
  },
  methods: {
    handleClick() {
        if (this.$refs["claimNotifications"])
            this.$refs["claimNotifications"].showPanel();
    },
    handleNotificationCount (e) {
          this.notificationCount = e
      }
  }
};
</script>
<style scoped>
</style>